import { render, staticRenderFns } from "./matching-card-compact-wrapper.vue?vue&type=template&id=296e9b70&scoped=true&"
import script from "./matching-card-compact-wrapper.vue?vue&type=script&lang=ts&"
export * from "./matching-card-compact-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-compact-wrapper.vue?vue&type=style&index=0&id=296e9b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e9b70",
  null
  
)

export default component.exports